import React from 'react';
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs';
// import Logo from '../../../../assets/images/svg/logo-solid.svg';
import * as styles from './header.module.scss';


export default function Header( { heading } ) {
  return (
    <header className={ styles.header }>
      <div className={ styles.headerContent }>
        <Breadcrumbs className={ styles.headerBreadcrumbs }/>

        <h1 className={ styles.headerHeading }>
          { heading }
        </h1>

        <div role="presentation" aria-hidden="true">
          <div className={ styles.headerDecorationGrad1 }>
          </div>
        </div>

        {/*<Logo className={ styles.headerLogo }/>*/}
      </div>
    </header>
  );
}